export default {
  "fr": {
    "company_client_type_id_list_162": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise BtoB"])},
    "company_client_type_id_list_167": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise BtoB et BtoC"])},
    "company_client_type_id_list_169": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprise BtoC"])}
  },
  "en": {
    
  }
}